// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flyout styles */

@layer defaults {
  :root {
    --readthedocs-flyout-max-width: 25em;

    --readthedocs-flyout-font-family: var(--readthedocs-font-family);
    --readthedocs-flyout-font-size: calc(var(--readthedocs-font-size) * 0.8);
    --readthedocs-flyout-line-height: 1.25em;
    --readthedocs-flyout-header-font-size: 1.125em;
    --readthedocs-flyout-dt-font-size: 1.125em;
    --readthedocs-flyout-dd-font-size: 1.125em;
    --readthedocs-flyout-line-height: 1.25em;

    --readthedocs-flyout-color: rgb(128, 128, 128);
    --readthedocs-flyout-background-color: rgb(39, 39, 37);
    --readthedocs-flyout-current-version-color: #27ae60;
    --readthedocs-flyout-section-heading-color: rgb(128, 128, 128);
    --readthedocs-flyout-item-link-color: rgb(252, 252, 252);
    --readthedocs-flyout-divider-color: #413d3d;
    --readthedocs-flyout-link-color: rgb(42, 128, 185);
  }
}

.container {
  position: fixed;
  max-width: var(--readthedocs-flyout-max-width);
  width: auto;
  height: auto;
  max-height: calc(100% - 100px);
  overflow-y: auto;
  line-height: var(--readthedocs-flyout-line-height);
}

.container.bottom-right {
  right: 20px;
  bottom: 50px;
}

.container.bottom-left {
  left: 20px;
  bottom: 50px;
}

.container.top-left {
  left: 20px;
  top: 50px;
}

.container.top-right {
  right: 20px;
  top: 50px;
}

:host > div {
  font-family: var(--readthedocs-flyout-font-family);
  font-size: var(--readthedocs-flyout-font-size);
  color: var(--readthedocs-flyout-color);
  background-color: var(--readthedocs-flyout-background-color);
  line-height: var(--readthedocs-flyout-line-height);
  z-index: 3000;
  padding: 0 10px;
  overflow-y: auto;
}

header {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.5em;
  align-items: center;
  cursor: pointer;
  background-color: var(--readthedocs-flyout-background-color);
  position: sticky;
  top: 0px;
  font-size: var(--readthedocs-flyout-header-font-size);
}

header > img.logo {
  /* Total height of 1.5 + 0.5 + 0.5 = 2.5em */
  max-height: 1.5em;
  width: auto;
  padding: 0.5em 0em;
  margin-right: 0.75em;
  /* Don't grow past content size, do shrink down to min-content */
  flex: 0 1 auto;
}

header > span {
  color: var(--readthedocs-flyout-current-version-color);
  font-size: var(--readthedocs-flyout-header-font-size);
  margin-left: 10px;
  /* Total height of 1 + 0.75 + 0.75 = 2.5em */
  padding: 0.75em 0em;
  line-height: 1em;
  /* Don't grow past content size or shrink below min-content */
  flex: 0 0 auto;
  /* Trim content to get ellipsis on wide content */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

header > span.version {
  /* Grow to fill parent based on content width, shrink content when needed (for ellipsis) */
  flex: 0 1 auto;
}

/* Give the flex box extra spacing to the left of the first span item. This puts
 * automatic spacing between the logo and the text detail spans */
header > span:first-of-type {
  margin-left: auto;
}

header > span svg.icon {
  color: rgb(128, 128, 128);
  height: var(--readthedocs-flyout-header-font-size);
  padding-right: 0.25em;
  vertical-align: middle;
}

main {
  padding: 5px;
  padding-bottom: 15px;
  margin-top: 5px;
}

main.closed {
  display: none;
}

dl {
  margin: 0;
  padding: 0;
}

dl > dt {
  font-size: var(--readthedocs-flyout-dt-font-size);
  color: var(--readthedocs-flyout-section-heading-color);
}

dl > dd {
  display: inline-block;
  margin: 0;
  font-size: var(--readthedocs-flyout-dd-font-size);
}

dd a {
  text-decoration: none;
  color: var(--readthedocs-flyout-item-link-color);
  padding: 6px;
  display: inline-block;
}

dd form {
  padding: 6px;
  margin: 0;
}

dd input {
  padding: 6px;
  font-size: 80%;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  margin: 20px 0;
  padding: 0;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: var(--readthedocs-flyout-divider-color);
}

small a {
  text-decoration: none;
  color: var(--readthedocs-flyout-link-color);
}
`, "",{"version":3,"sources":["webpack://./src/flyout.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE;IACE,oCAAoC;;IAEpC,gEAAgE;IAChE,wEAAwE;IACxE,wCAAwC;IACxC,8CAA8C;IAC9C,0CAA0C;IAC1C,0CAA0C;IAC1C,wCAAwC;;IAExC,8CAA8C;IAC9C,sDAAsD;IACtD,mDAAmD;IACnD,8DAA8D;IAC9D,wDAAwD;IACxD,2CAA2C;IAC3C,kDAAkD;EACpD;AACF;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,8CAA8C;EAC9C,sCAAsC;EACtC,4DAA4D;EAC5D,kDAAkD;EAClD,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,4DAA4D;EAC5D,gBAAgB;EAChB,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,qDAAqD;EACrD,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,cAAc;EACd,iDAAiD;EACjD,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0FAA0F;EAC1F,cAAc;AAChB;;AAEA;iEACiE;AACjE;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kDAAkD;EAClD,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;EACd,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C","sourcesContent":["/* Flyout styles */\n\n@layer defaults {\n  :root {\n    --readthedocs-flyout-max-width: 25em;\n\n    --readthedocs-flyout-font-family: var(--readthedocs-font-family);\n    --readthedocs-flyout-font-size: calc(var(--readthedocs-font-size) * 0.8);\n    --readthedocs-flyout-line-height: 1.25em;\n    --readthedocs-flyout-header-font-size: 1.125em;\n    --readthedocs-flyout-dt-font-size: 1.125em;\n    --readthedocs-flyout-dd-font-size: 1.125em;\n    --readthedocs-flyout-line-height: 1.25em;\n\n    --readthedocs-flyout-color: rgb(128, 128, 128);\n    --readthedocs-flyout-background-color: rgb(39, 39, 37);\n    --readthedocs-flyout-current-version-color: #27ae60;\n    --readthedocs-flyout-section-heading-color: rgb(128, 128, 128);\n    --readthedocs-flyout-item-link-color: rgb(252, 252, 252);\n    --readthedocs-flyout-divider-color: #413d3d;\n    --readthedocs-flyout-link-color: rgb(42, 128, 185);\n  }\n}\n\n.container {\n  position: fixed;\n  max-width: var(--readthedocs-flyout-max-width);\n  width: auto;\n  height: auto;\n  max-height: calc(100% - 100px);\n  overflow-y: auto;\n  line-height: var(--readthedocs-flyout-line-height);\n}\n\n.container.bottom-right {\n  right: 20px;\n  bottom: 50px;\n}\n\n.container.bottom-left {\n  left: 20px;\n  bottom: 50px;\n}\n\n.container.top-left {\n  left: 20px;\n  top: 50px;\n}\n\n.container.top-right {\n  right: 20px;\n  top: 50px;\n}\n\n:host > div {\n  font-family: var(--readthedocs-flyout-font-family);\n  font-size: var(--readthedocs-flyout-font-size);\n  color: var(--readthedocs-flyout-color);\n  background-color: var(--readthedocs-flyout-background-color);\n  line-height: var(--readthedocs-flyout-line-height);\n  z-index: 3000;\n  padding: 0 10px;\n  overflow-y: auto;\n}\n\nheader {\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 0.5em;\n  align-items: center;\n  cursor: pointer;\n  background-color: var(--readthedocs-flyout-background-color);\n  position: sticky;\n  top: 0px;\n  font-size: var(--readthedocs-flyout-header-font-size);\n}\n\nheader > img.logo {\n  /* Total height of 1.5 + 0.5 + 0.5 = 2.5em */\n  max-height: 1.5em;\n  width: auto;\n  padding: 0.5em 0em;\n  margin-right: 0.75em;\n  /* Don't grow past content size, do shrink down to min-content */\n  flex: 0 1 auto;\n}\n\nheader > span {\n  color: var(--readthedocs-flyout-current-version-color);\n  font-size: var(--readthedocs-flyout-header-font-size);\n  margin-left: 10px;\n  /* Total height of 1 + 0.75 + 0.75 = 2.5em */\n  padding: 0.75em 0em;\n  line-height: 1em;\n  /* Don't grow past content size or shrink below min-content */\n  flex: 0 0 auto;\n  /* Trim content to get ellipsis on wide content */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\nheader > span.version {\n  /* Grow to fill parent based on content width, shrink content when needed (for ellipsis) */\n  flex: 0 1 auto;\n}\n\n/* Give the flex box extra spacing to the left of the first span item. This puts\n * automatic spacing between the logo and the text detail spans */\nheader > span:first-of-type {\n  margin-left: auto;\n}\n\nheader > span svg.icon {\n  color: rgb(128, 128, 128);\n  height: var(--readthedocs-flyout-header-font-size);\n  padding-right: 0.25em;\n  vertical-align: middle;\n}\n\nmain {\n  padding: 5px;\n  padding-bottom: 15px;\n  margin-top: 5px;\n}\n\nmain.closed {\n  display: none;\n}\n\ndl {\n  margin: 0;\n  padding: 0;\n}\n\ndl > dt {\n  font-size: var(--readthedocs-flyout-dt-font-size);\n  color: var(--readthedocs-flyout-section-heading-color);\n}\n\ndl > dd {\n  display: inline-block;\n  margin: 0;\n  font-size: var(--readthedocs-flyout-dd-font-size);\n}\n\ndd a {\n  text-decoration: none;\n  color: var(--readthedocs-flyout-item-link-color);\n  padding: 6px;\n  display: inline-block;\n}\n\ndd form {\n  padding: 6px;\n  margin: 0;\n}\n\ndd input {\n  padding: 6px;\n  font-size: 80%;\n}\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  margin: 20px 0;\n  padding: 0;\n  border-top-width: 1px;\n  border-top-style: solid;\n  border-top-color: var(--readthedocs-flyout-divider-color);\n}\n\nsmall a {\n  text-decoration: none;\n  color: var(--readthedocs-flyout-link-color);\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
